import { useCallback, useEffect, useState } from "react";
import {
  useEmployeePledgeLookupsQuery,
  useEmployeePledgeQuery,
} from "./hooks/useEmployeePledge";
import EmployeePledgeSummary from "./Summary";
import {
  createEmployeePledgeViewModel,
  EmployeePledgeViewModel,
} from "../../../viewModels";
import { useNavigate, useParams } from "react-router-dom";
import { Button } from "../../common/VFX-UI";
import usePledgeStyles from "./styles";
import { ArrowLeft, Printer } from "react-bootstrap-icons";

const PledgeSuccess = () => {
  const navigate = useNavigate();
  const pledgeStyles = usePledgeStyles();
  const { campaignId } = useParams();
  const pledgeLookupsQuery = useEmployeePledgeLookupsQuery();
  const pledgeQuery = useEmployeePledgeQuery(campaignId);

  const [employeePledgeDetails, setEmployeePledgeDetails] = useState(
    new EmployeePledgeViewModel()
  );
  const [printSummary, setPrintSummary] = useState<(() => void) | null>(null);
  const handlePrintReady = useCallback(
    (print: () => void) => setPrintSummary(() => print),
    []
  );

  useEffect(() => {
    if (!pledgeQuery?.isLoading && pledgeQuery.data?.result?.id) {
      const employeePledgeDetails = createEmployeePledgeViewModel(
        pledgeQuery.data.result
      );
      setEmployeePledgeDetails(employeePledgeDetails);
    }
  }, [pledgeQuery.isLoading, pledgeQuery.data]);

  return (
    <>
      <nav style={pledgeStyles.summaryNavigation} aria-label="Pledge navigation">
        <Button
          onClick={() => navigate("/")}
          style={pledgeStyles.summaryBackButton}
          className="btn"
        >
          <ArrowLeft aria-hidden="true" />
          Back to campaign
        </Button>
        {/*{printSummary && (*/}
        {/*  <Button*/}
        {/*    onClick={printSummary}*/}
        {/*    style={pledgeStyles.summaryBackButton}*/}
        {/*    className="btn"*/}
        {/*  >*/}
        {/*    <Printer aria-hidden="true" />*/}
        {/*    Print summary*/}
        {/*  </Button>*/}
        {/*)}*/}
      </nav>
      <EmployeePledgeSummary
        summary={employeePledgeDetails}
        lookups={pledgeLookupsQuery.data?.result}
        isPledgeSuccess={true}
        onPrintReady={handlePrintReady}
      />
    </>
  );
};

export default PledgeSuccess;
